<template>
    <div class="operator-wrapper" @click="operatorHandler">
        <div class="operator-button" v-for="item in items" :key="item.id" :attr-id="item.id">{{ item.label }}</div>
        <TwoLayerPopup
            class="operator-popup"
            :menus="classMenu"
            direct="bottom"
            :left="-150"
            :topOrBottom="1"
            :isShow="isShowPopup"
            @menuChange="menuChange"
            @menuHide="menuHide"
        />
    </div>
</template>

<script>
import TwoLayerPopup from "@/views/zhiji/bComponents/popupMenu/TwoLayerPopup";
import { recursionTrans } from "@/views/zhiji/js/common/util.js";
import i18n from "@/i18n";

export default {
    name: "OperatorColumn",
    props: ["data", "row"],
    components: {
        TwoLayerPopup
    },
    data() {
        return {
            isShowPopup: false
        };
    },
    computed: {
        labels() {
            return {
                transfer: this.$t("zhiji.common.transfer"),
                online: this.$t("zhiji.knowlege.online"),
                offline: this.$t("zhiji.knowlege.offline"),
                delete: this.$t("zhiji.common.delete"),
                setToFirst: this.$t("zhiji.knowlege.setToFirst"),
                setToReveal: this.$t("zhiji.knowlege.setToReveal")
            };
        },
        items() {
            return this.data.map(item => {
                return {
                    label: this.labels[item],
                    id: item
                };
            });
        },
        classMenu() {
            let treeData = this.getStorePorp("treeData").children || [];
            return recursionTrans(
                treeData,
                function(treesData) {
                    return {
                        value: treesData.id,
                        label: treesData.label
                    };
                },
                "children"
            );
        }
    },
    mounted() {
        window.document.addEventListener("click", this.windowClick);
    },
    destroyed() {
        window.document.removeEventListener("click", this.windowClick);
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.questionListPage[propName];
        },
        defaultLang() {
            const defaultLang = this.$store.state.zhiji.gameState.defaultLang;
            return defaultLang ? defaultLang : "en";
        },
        operatorHandler(event) {
            const target = event.target;
            const itemId = target.getAttribute("attr-id");

            itemId === "transfer" ? (this.isShowPopup = true) : itemId && this.tableClickAction(itemId);
        },
        // table按钮操作总入口
        tableClickAction(itemId) {
            const handlers = {
                delete: this.deleteAction,
                online: this.onlineAction,
                offline: this.offlineAction,
                setToFirst: this.setToFirstAction,
                setToReveal: this.setToRevealAction
            };

            handlers[itemId].call(null, itemId);
        },
        onlineAction(itemId) {
            if (this.row.addData.langType === this.defaultLang()) {
                // 默认语种，提示被影响的相关标问
                this.effectQuestion(i18n.t("zhiji.knowlege.onlineRelatedTip"), () => {
                    this.$store.dispatch("zhiji/quesOnlineStatusChange", {
                        status: itemId,
                        questionId: this.row.rowId
                    });
                });
            } else {
                this.$store.dispatch("zhiji/quesOnlineStatusChange", {
                    status: itemId,
                    questionId: this.row.rowId
                });
            }
        },
        offlineAction(itemId) {
            if (this.row.addData.langType === this.defaultLang()) {
                // 默认语种，提示被影响的相关标问
                this.effectQuestion(i18n.t("zhiji.knowlege.offlineRelatedTip"), () => {
                    this.$store.dispatch("zhiji/quesOnlineStatusChange", {
                        status: itemId,
                        questionId: this.row.rowId
                    });
                });
            } else {
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "tip",
                        message: i18n.t("zhiji.knowlege.offlineQuesTip1"),
                        cancel: () => {},
                        confirm: () => {
                            this.$store.dispatch("zhiji/quesOnlineStatusChange", {
                                status: itemId,
                                questionId: this.row.rowId
                            });
                        }
                    }
                });
            }
        },
        deleteAction() {
            if (this.row.addData.langType === this.defaultLang()) {
                // 默认语种，提示被影响的相关标问
                this.effectQuestion(i18n.t("zhiji.knowlege.deleteRelatedTip"), () => {
                    this.$store.dispatch("zhiji/deleteQuestions", {
                        questionId: [this.row.rowId]
                    });
                });
            } else {
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "tip",
                        message: i18n.t("zhiji.knowlege.deleteQuesTip1"),
                        cancel: () => {},
                        confirm: () => {
                            this.$store.dispatch("zhiji/deleteQuestions", {
                                questionId: [this.row.rowId]
                            });
                        }
                    }
                });
            }
        },
        setToFirstAction() {
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: i18n.t("zhiji.knowlege.setFirstTip"),
                    cancel: () => {},
                    confirm: () => {
                        this.$store.dispatch("zhiji/setFirstQuestion", {
                            questionId: this.row.rowId
                        });
                    }
                }
            });
        },
        setToRevealAction() {
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: i18n.t("zhiji.knowlege.setNoAnswerTip"),
                    confirm: () => {
                        this.$store.dispatch("zhiji/setRevealQuestion", {
                            questionId: this.row.rowId
                        });
                    }
                }
            });
        },
        menuChange(option) {
            this.isShowPopup = false;
            this.$store.dispatch("zhiji/transferQuestions", {
                classId: option.value,
                questionId: this.row.rowId
            });
        },
        menuHide() {
            this.isShowPopup = false;
        },
        windowClick(event) {
            if (!this.$el.contains(event.target)) {
                this.isShowPopup = false;
            }
        },
        // 提示被影响的相关标问
        effectQuestion(tipTxt, callBack) {
            this.zhiji
                .requestByServiceName("getRelatedQuestion", {
                    questionId: this.row.rowId
                })
                .then(resp => {
                    let tipStr = tipTxt;
                    resp.map(item => {
                        tipStr += `\n ${item.question}(${i18n.t("zhiji.knowlege.questionName")})， question_id=${item.questionId}`;
                    });
                    resp.length &&
                        this.$store.dispatch("zhiji/showModal", {
                            type: "MessageModal",
                            data: {
                                type: "tip",
                                message: tipStr,
                                cancel: () => {},
                                confirm: () => {
                                    callBack();
                                }
                            }
                        });
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.operator-wrapper {
    white-space: nowrap;
    .operator-button {
        display: inline-block;
        font-size: 12px;
        margin-right: 8px;
        border: 1px solid #d8e4f0;
        padding: 2px 8px;
        background: #fff;
        border-radius: 4px;

        &:hover {
            color: #2ec2ff;
            cursor: pointer;
        }
    }
}
</style>
